import {
  ContentType,
  FoodMenuData,
  FoodMenuItem,
} from '@bm-js/atlascloud-shared'
import { useMemo, useState } from 'react'
import { isEditor } from '../utils/misc'
import { useMargin } from '../utils/hooks'
import { CustomerButton } from './CustomerButton'

interface FoodMenuProps {
  content: ContentType<FoodMenuData>
}

const ALL_KEY = 'Alla'

export const FoodMenu = ({ content }: FoodMenuProps) => {
  const items = content.data.items
  const margins = useMargin(content)

  const [currentCategory, setCurrentCategory] = useState(ALL_KEY)

  const containerClass = useMemo(() => {
    let containerClass = 'md:grid-cols-3'

    if (isEditor()) {
      containerClass = '@4xl/top:grid-cols-3 @2xl/top:grid-cols-2'
    }

    return containerClass
  }, [])

  const itemsByCategory = useMemo<Record<string, FoodMenuItem[]>>(() => {
    const itemsByCategory: Record<string, FoodMenuItem[]> = {}
    items.forEach((item) => {
      if (!item.category) return
      itemsByCategory[item.category] = [
        ...(itemsByCategory[item.category] || []),
        item,
      ]
    })
    return { [ALL_KEY]: items, ...itemsByCategory }
  }, [items])

  const filteredItems = useMemo(() => {
    return itemsByCategory[currentCategory]
  }, [itemsByCategory, currentCategory])

  const hasCategories = useMemo(() => {
    return Object.keys(itemsByCategory).length > 1
  }, [itemsByCategory])

  return (
    <>
      {hasCategories && (
        <div className='flex flex-wrap gap-2 mb-4'>
          {Object.keys(itemsByCategory).map((category) => (
            <CustomerButton
              key={category}
              onClick={() => setCurrentCategory(category)}
              btnType={currentCategory === category ? 'filled' : 'outline'}
            >
              {category} ({itemsByCategory[category].length})
            </CustomerButton>
          ))}
        </div>
      )}
      <div className={`grid grid-cols-1 gap-4 ${margins} ${containerClass}`}>
        {filteredItems.map((item) => (
          <div
            key={item.uuid}
            className='flex flex-col justify-between rounded-2xl border border-gray-300 p-4 shadow-sm'
          >
            <div className='flex justify-between items-start'>
              <h2 className='font-semibold text-lg'>{item.title}</h2>
              <span className='font-medium'>{item.price} kr</span>
            </div>
            <p className='text-gray-500 text-sm mt-1'>{item.description}</p>
          </div>
        ))}
      </div>
    </>
  )
}
